import client from "./client";

export async function fetchRules({ signal } = {}) {
    const res = await client.post("fetch-rules", undefined, { signal });
    const rules = res?.data?.data?.naturaldata ?? [];
    return rules[0] ?? null;
}
